import type { WeatherCondition } from "../types.ts";

export function weatherCodeToCondition(code: number | null): WeatherCondition {
	if (code === null) return "cloud";
	if (code <= 1) return "sun";
	if (code === 2) return "cloud-sun";
	if (code === 3 || code === 45 || code === 48) return "cloud";
	if (code >= 51) return "cloud-rain";
	return "cloud";
}

const DESCRIPTIONS: Record<number, string> = {
	0: "Céu limpo",
	1: "Predomínio de sol",
	2: "Parcialmente nublado",
	3: "Nublado",
	45: "Névoa",
	48: "Névoa",
	51: "Garoa",
	53: "Garoa",
	55: "Garoa",
	56: "Garoa congelante",
	57: "Garoa congelante",
	61: "Chuva",
	63: "Chuva",
	65: "Chuva",
	66: "Chuva congelante",
	67: "Chuva congelante",
	71: "Neve",
	73: "Neve",
	75: "Neve",
	77: "Grãos de neve",
	80: "Pancadas de chuva",
	81: "Pancadas de chuva",
	82: "Pancadas de chuva",
	85: "Pancadas de neve",
	86: "Pancadas de neve",
	95: "Tempestade",
	96: "Tempestade com granizo",
	99: "Tempestade com granizo",
};

export function weatherCodeToDescription(code: number | null): string {
	if (code === null) return "—";
	return DESCRIPTIONS[code] ?? "—";
}
